import { mapShareContactTypes, ShareContactTypes } from "../HeyTraderTypes/ShareContactTypes";
import { CommonSharedByType, mapCommonSharedByType } from "../Share/CommonSharedByType";

/* **************************************************** Finishing Shedule Feature Data */
export interface FSFeatureData {
    id: number;
    fs_feature_id: number;
    category: string;
    location_name: string | null;
    location_id: number | null;
}

export const mapFSFeatureData = (data: any): FSFeatureData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSFeatureData = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        category: data.category,
        location_name: data.location_name || null,
        location_id: data.location_id || null,
    };

    return res;
};

export const mapFSFeatureDatas = (data: any[]): FSFeatureData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSFeatureData);
};


/* **************************************************** Finishing Shedule Feature */
export interface FSFeature {
    id: number;
    project_id: number;
    feature: 'Light' | 'Door' | 'Paint' | 'Bathroom' | 'Kitchen' | 'Tiles' | 'Floor Finishing' | 'Others';
    status: 1 | 0;
    can_edit: boolean;
    shared_by: CommonSharedByType | null;
    data: FSFeatureData[];
    share_list: ShareContactTypes[];
}

export const mapFSFeature = (data: any): FSFeature => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSFeature = {
        id: data.id,
        project_id: data.project_id,
        feature: data.feature,
        status: data.status,
        can_edit: data.can_edit,
        shared_by: data.shared_by ? mapCommonSharedByType(data.shared_by) : null,
        data: Array.isArray(data.data) ? mapFSFeatureDatas(data.data) : [],
        share_list: Array.isArray(data.share_list) ? mapShareContactTypes(data.share_list) : [],
    };

    return res;
};

export const mapFSFeatures = (data: any[]): FSFeature[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSFeature);
};


/* **************************************************** Finishing Shedule Project */
export interface FSProject {
    project_id: number;
    job_number: string;
    project_type: 'CP' | 'DP';
    description: string;
    status: 'Current' | 'Ongoing' | 'Completed';
    user_id: number;
    address: string;
    post_code: string;
    is_fs_project_list: boolean;
    feature_list: FSFeature[];
    is_own_project: boolean;
    contact: ShareContactTypes[];
    share_list?: ShareContactTypes[];
    shared_by: CommonSharedByType | null;
    can_edit?: boolean;
}

export const mapFSProject = (data: any): FSProject => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSProject = {
        project_id: data.project_id,
        job_number: data.job_number,
        project_type: data.project_type,
        description: data.description,
        status: data.status,
        user_id: data.user_id,
        address: data.address,
        post_code: data.post_code,
        is_fs_project_list: data.is_fs_project_list,
        feature_list: Array.isArray(data.feature_list) ? mapFSFeatures(data.feature_list) : [],
        is_own_project: data.is_own_project,
        contact: Array.isArray(data.contact) ? mapShareContactTypes(data.contact) : [],
        share_list: Array.isArray(data.share_list) ? mapShareContactTypes(data.share_list) : [],
        shared_by: data.shared_by ? mapCommonSharedByType(data.shared_by) : null,
        can_edit: data.can_edit,
    };

    return res;
};

export const mapFSProjects = (data: any[]): FSProject[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSProject);
};
